import users from './users'

export default [
  {
    title: 'Inicio',
    route: 'home',
    icon: 'HomeIcon',
    permisos: ['usu_usuario_consultar', 'usu_rol_consultar', 'rep_log_actividades'],
  },
  ...users,
  {
    title: 'Admision',
    icon: 'InboxIcon',
    permisos: ['adm_consultar_admision'],
    children: [
      {
        title: 'Admision',
        route: 'consultar_admision',
        icon: 'SearchIcon',
        permiso: 'adm_consultar_admision',
      },
    ],
  },
  {
    title: 'Prevención',
    icon: 'ShieldIcon',
    permisos: ['enfprev_asignar_paquete'],
    children: [
      {
        title: 'Paquetes Preventivos',
        route: 'consultar_paquetes_preventivos',
        icon: 'SearchIcon',
        permiso: 'enfprev_consultar_paquetes',
      },
      {
        title: 'Paquetes Asignados',
        route: 'consulta_paquete_asignado',
        icon: 'PackageIcon',
        permiso: 'enfprev_asignar_paquete',
      },
    ],
  },
  {
    title: 'Administracion',
    icon: 'LockIcon',
    permisos: ['adm_consultar_doctor'],
    children: [
      {
        title: 'Consultar Doctores',
        route: 'consultar_doctor',
        icon: 'SearchIcon',
        permiso: 'adm_consultar_doctor',
      },
      {
        title: 'Consultar Auxiliar',
        route: 'consultar_auxiliar',
        icon: 'SearchIcon',
        permiso: 'adm_consultar_auxiliar',
      },
      {
        title: 'Establecimientos',
        route: 'establecimientos',
        icon: 'SearchIcon',
        permiso: 'adm_consultar_doctor',
      },
      {
        title: 'Consentimiento Informado',
        route: 'consentimiento_informado',
        icon: 'SearchIcon',
        permiso: 'adm_consultar_consentimiento',
      },
    ]
  },
  
  {
    title: 'Citas',
    icon: 'CalendarIcon',
    permisos: ['citamedica_consultar_cita'],
    children: [
      {
        title: 'Consultar',
        route: 'consultar_citas',
        icon: 'SearchIcon',
        permiso: 'citamedica_consultar_cita',
      },
      
    ],
  },
  {
    title: 'Derivaciones',
    icon: 'SendIcon',
    permisos: ['derivaciones_consultar'],
    children: [
      {
        title: 'Consultar Derivaciones',
        route: 'derivaciones',
        icon: 'SearchIcon', // Cambia el icono según corresponda
        permiso: 'derivaciones_consultar', // Define el permiso necesario
      },

      {
        title: 'Interconsultas',
        route: 'interconsultas',
        icon: 'SearchIcon', // Cambia el icono según corresponda
        permiso: 'interconsultas_consultar', // Define el permiso necesario
      },
    
    ],
  },

  {
    title: 'Signos Vitales',
    icon: 'HeartIcon',
    permisos: ['citamedica_crear_signosvital'],
    children: [
      {
        title: 'Consultar Signos Vitales',
        route: 'consultar_signos_vital',
        icon: 'SearchIcon',
        permiso: 'citamedica_crear_signosvital',
      },
    ],
  },

  {
    title: 'Imagenes',
    icon: 'ImageIcon',
    permisos: ['consultar_imagen_programada'],
    children: [
      {
        title: 'Imagenes Programadas',
        route: 'consultar-imagenes',
        icon: 'SearchIcon', // Cambia el icono según corresponda
        permiso: 'consultar_imagen_programada', // Define el permiso necesario
      },
    ],
  },
  {
    title: 'Auditoria Medica',
    icon: 'FileTextIcon',
    permisos: ['atencionmedica_consultaratencionmedica'],
    children: [
      {
        title: 'Atenciones Medicas',
        route: 'atenciones-medicas',
        icon: 'SearchIcon',
        permiso: 'atencionmedica_consultaratencionmedica',
      }
    ],
  },
  {
    title: 'Farmacia',
    icon: 'BoxIcon',
    permisos: ['consultar_recetas'],
    children: [
      {
        title: 'Recetas por Retirar',
        route: 'consultar_receta_creada',
        icon: 'InboxIcon', // Cambia el icono según corresponda
        permiso: 'consultar_recetas', // Define el permiso necesario
      },
    ],
  },
  {
    title: 'Laboratorio',
    icon: 'CpuIcon',
    permisos: ['consultar_examen_lab'],
    children: [
      {
        title: 'Exámenes Lab',
        route: 'consultar_examen_lab',
        icon: 'CopyIcon', // Cambia el icono según corresponda
        permiso: 'consultar_examen_lab', // Define el permiso necesario
      },
    ],
  },
  {
    title: 'Terapia',
    icon: 'FolderPlusIcon',
    permisos: ['consultar_terapias_programadas'],
    children: [
      {
        title: 'Terapias Programadas',
        route: 'consultar_terapia_programada',
        icon: 'CalendarIcon', // Cambia el icono según corresponda
        permiso: 'consultar_terapias_programadas', // citamedica_crear_signosvital
      },
    ],
  },
  {
    title: 'Proceso Clinico',
    icon: 'TrelloIcon',
    permisos: ['consultar_procesoclinico'],
    children: [
      {
        title: 'Proceso Clinico',
        route: 'consultar_procesoclinico',
        icon: 'CopyIcon', // Cambia el icono según corresponda
        permiso: 'consultar_procesoclinico', // Define el permiso necesario
      }
    ],
  },
  {
    title: 'Cartera Servicios',
    icon: 'LayersIcon',
    permisos: ['consultar_cartera_examen', 'consultar_cartera_proceso'],
    children: [
      {
        title: 'Cartera Atencion Medica',
        route: 'cartera_atencion_medica',
        icon: 'LayersIcon',
        permiso: ['consultar_cartera_examen', 'consultar_cartera_proceso'],
      },
      {
        title: 'Cartera Farmaco',
        route: 'consultar_cartera_farmaco',
        icon: 'LayersIcon',
        permiso: ['consultar_cartera_examen', 'consultar_cartera_proceso'],
      },
      {
        title: 'Cartera Insumos',
        route: 'consultar_cartera_insumo',
        icon: 'LayersIcon',
        permiso: ['consultar_cartera_examen', 'consultar_cartera_proceso'],
      },
      {
        title: 'Cartera Terapias',
        route: 'consultar_cartera_terapia',
        icon: 'LayersIcon',
        permiso: ['consultar_cartera_examen', 'consultar_cartera_proceso'], //
      },
      {
        title: 'Cartera de Examenes',
        route: 'consultar_cartera_examen',
        icon: 'LayersIcon',
        permiso: ['consultar_cartera_examen', 'consultar_cartera_proceso'],
      },
      {
        title: 'Cartera Imagenes',
        route: 'consultar_cartera_imagen',
        icon: 'LayersIcon',
        permiso: ['consultar_cartera_examen', 'consultar_cartera_proceso'],
      },
      {
        title: 'Cartera Proceso Clinico',
        route: 'consultar_cartera_procesoclinico',
        icon: 'SearchIcon',
        permiso: 'consultar_cartera_proceso',
      },
        {
        title: 'Cartera Odontologia',
        route: 'consultar_cartera_odontologia',
        icon: 'SearchIcon',
        permiso: ['consultar_cartera_examen', 'consultar_cartera_proceso'],
      },
    ],
  },
  {
    title: 'Producción',
    icon: 'BarChartIcon',
    permisos: ['consultar_produccion'],
    children: [
      {
        title: 'Tablas y gráficos',
        route: 'produccion_tablas_graficos',
        icon: 'SearchIcon',
        permiso: 'consultar_produccion',
      },
      {
        title: 'Paquetes servicios',
        route: 'produccion_paquetes_servicios',
        icon: 'SearchIcon',
        permiso: 'consultar_produccion',
      },
      {
        title: 'Servicios más solicitados',
        route: 'produccion_servicios_mas_solicitados',
        icon: 'SearchIcon',
        permiso: 'consultar_produccion',
      },
      {
        title: 'Marketing enfermedades',
        route: 'produccion_marketing_enfermedades',
        icon: 'SearchIcon',
        permiso: 'consultar_produccion',
      },
      {
        title: 'Marketing geolocalizado',
        route: 'produccion_marketing_geolocalizado',
        icon: 'SearchIcon',
        permiso: 'consultar_produccion',
      },
      {
        title: 'Regresión lineal',
        route: 'produccion_regresion_lineal',
        icon: 'SearchIcon',
        permiso: 'consultar_produccion',
      },
      {
        title: 'Análisis costos',
        route: 'produccion_analisis_costos',
        icon: 'SearchIcon',
        permiso: 'consultar_produccion',
      },
      {
        title: 'Predicción demanda',
        route: 'produccion_prediccion_demanda',
        icon: 'SearchIcon',
        permiso: 'consultar_produccion',
      },
      {
        title: 'Optimización recursos',
        route: 'produccion_optimizacion_recursos',
        icon: 'SearchIcon',
        permiso: 'consultar_produccion',
      },
      {
        title: 'KPI producción',
        route: 'produccion_kpi',
        icon: 'SearchIcon',
        permiso: 'consultar_produccion',
      },
      {
        title: 'Rentabilidad departamentos',
        route: 'produccion_rentabilidad_departamentos',
        icon: 'SearchIcon',
        permiso: 'consultar_produccion',
      },
      {
        title: 'Dashboard CEO',
        route: 'produccion_dashboard_ceo',
        icon: 'SearchIcon',
        permiso: 'consultar_produccion',
      },
    ],
  },
  {
    title: 'Reporte',
    icon: 'TrendingUpIcon',
    permisos: ['rep_archivo_plano'],
    children: [
      {
        title: 'Log de actividades',
        route: 'log_actividad',
        icon: 'ActivityIcon',
        permiso: 'rep_log_actividades',
      },
      {
        title: 'Generacion Archivos Planos',
        route: 'archivo_plano',
        icon: 'TrelloIcon',
        permiso: 'rep_archivo_plano',
      },

      {
        title: 'Generacion Archivos Pdf',
        route: 'archivo_pdf',
        icon: 'TrelloIcon',
        permiso: 'rep_archivo_plano',
      },
    ],
  },
]
